import { Component } from '@angular/core';

import { DialogRef, ModalComponent, CloseGuard } from 'ngx-modialog-11';
import { BSModalContext } from 'ngx-modialog-11/plugins/bootstrap';

export class MessageBoxContext extends BSModalContext {
  constructor(
    public title: string,
    public description: string,
    public descriptionInfo: string,
    public status: string,

    public link: Object,

    public buttons: Object[],
    public buttonsClass: string,

    public onClose: Function,
    public isClose: boolean,

    public svg: any,
    public classes: string,
    public classPopup: string,
  ) {
    super();
  }
}

@Component({
  selector: 'modal-content',
  templateUrl: './message-box.component.html',
  styleUrls: ['./message-box.component.scss'],
})
export class MessageBoxComponent implements CloseGuard, ModalComponent<MessageBoxContext> {
  context: MessageBoxContext;

  wrongAnswer: boolean;

  constructor(public dialog: DialogRef<MessageBoxContext>) {
    this.context = dialog.context;
    this.wrongAnswer = true;
    dialog.setCloseGuard(this);
  }

  onClick(callback) {
    if (callback) {
      callback();
    }

    this.close();
  }

  onClose() {
    this.close();
  }

  beforeDismiss(): boolean {
    return true;
  }

  beforeClose(): boolean {
    return this.wrongAnswer;
  }

  private close() {
    this.wrongAnswer = false;
    this.dialog.close();

    if (this.context.onClose) {
      this.context.onClose();
    }
  }
}
